import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

import { LpFundDataService } from '../../services/lp/lp-fund-data.service';
import {LpFundListItemReqRes} from './LpFundListItemReqRes.model';

@Injectable()
export class FundsService {

  constructor(
    private lpFundDataService: LpFundDataService
  ) { }

  getFundsList(): Observable<LpFundListItemReqRes[]> {
    return this.lpFundDataService.getLpFundsList();
  }

  getPendingFundsList(): Observable<LpFundListItemReqRes[]> {
    return this.lpFundDataService.getPendingFunds();
  }

  getFundOpportunitiesList(): Observable<LpFundListItemReqRes[]> {
    return this.lpFundDataService.getFundsOpportunities();
  }
}

